// extracted by mini-css-extract-plugin
export default {"container":"reset-password_container__8swqy","header":"reset-password_header__eHXuv","info":"reset-password_info__yp94G","button":"reset-password_button__VJSKV"};